export const breakpoints = {
    lsrpSidebar: 1140,
    desktop: 960
};

export const LSRP_SIDEBAR_MEDIA_QUERY = `@media only screen and (min-width: ${breakpoints.lsrpSidebar}px)`;
